"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformAudioComponentParameters = void 0;
exports.PlatformAudioComponentParameters = [
    {
        id: 'recording',
        label: 'Recording',
        description: 'Input Param - Audio file to play',
        type: 'string',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'start',
        label: 'Start Time',
        description: 'Input Param - Start time for the audio slice',
        type: 'float',
        paramType: 'FLOAT',
        required: false,
    },
    {
        id: 'end',
        label: 'End Time',
        description: 'Input Param - End time for the audio slice',
        type: 'float',
        paramType: 'FLOAT',
        required: false,
    },
    {
        id: 'showAmplitudes',
        label: 'Show Amplitudes',
        description: 'Input Param - Show the amplitude of the audio',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'isReferenceAudio',
        label: 'Is Reference Audio',
        description: 'Input Param - Mark the audio as reference audio recording',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'forceReplay',
        label: 'Force Replay',
        description: 'Input Param - Require the user to replay the audio before rendering',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
];
//# sourceMappingURL=PlatformAudioComponent.js.map